export default "__VITE_ASSET__CSWYnqGG__"